import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffCrudInformation = () => import('./staff/crudInformation')
const ViewStaffReports = () => import('./staff/reports')

Vue.use(Router)

const router =
  [
    {
      path: '/st/social-networks',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'SocialNetworksStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Redes sociales',
          }                            
        },
        {
          path: 'configuration',
          name: 'SocialNetworksStaffConfiguration',
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuracion de redes sociales',
          }                            
        }, 
        {
          path: 'crud-information',
          name: 'SocialNetworksStaffCrudInformation',
          component: ViewStaffCrudInformation,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Información de redes sociales',
          }                            
        },    
        {
          path: 'reports',
          name: 'SocialNetworksStaffReports',
          component: ViewStaffReports,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes de redes sociales',
          }                            
        },                    
      ]
    },

    {
      path: '/cu/social-networks',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/social-networks',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
